/**
 * @module utils/resolvable
 */

/**
 * @typedef {module:utils/array~Array} Array
 * @typedef {module:utils/object~Object} Object
 * @typedef {Object|{resolve:function(*),reject:function(Error)}} Resolver
 * @typedef {Array<promise,Resolver>} Resolvable
 */

import array from './array.js'
import object from './object.js'

const saved = []

const save = (
  resolve,
  reject
) => {
  saved.push(object(null, { resolve, reject }))
}

/**
 * Returns a promise and the associated resolve/reject
 * as an object extending a target, if any
 * @param {Object|null} target
 * @returns {Resolvable}
 */
export default (
  target = null
) => {
  return array([
    new Promise(save),
    object(target, saved.pop())
  ])
}
